import * as React from 'react';
import {observer} from "mobx-react-lite";
import {HotIoc} from "../../models/stats";
import {HotIocStore} from "../../stores/stats";
import {Carousel, Col, Row} from "react-bootstrap";
import {Link} from "react-router-dom";
import Backdrop from "../Backdrop";


const HotIocs = observer(function HotIocs(props: {
    store: HotIocStore
}) {
    const {store} = props
    return <>
        {store.error ? store.error : ''}
        <Backdrop hidden={!store.loading} />

        <HotIocsList items={store.data} />

        <Carousel.Caption>
            <h3>Hot IOCs</h3>
            <p>Most frequently requested IOCs</p>
        </Carousel.Caption>
    </>
});

const HotIocsList = observer(function HotIocsList(props: {items: HotIoc[]}) {
    return <Row className="stats-data">
        {props.items.map((e) => <HotIocsView item={e} key={e.id} />)}
    </Row>
})

const HotIocsView = observer(function HotIocsView(props: {item: HotIoc}) {
    const {item} = props
    return <Col xs={12}><Link to={"/ioc/"+item.ioc}>{item.ioc}</Link></Col>
})

export default HotIocs